
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-40">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg" style={{ fontFamily: '"Pacifico", serif' }}>M</span>
            </div>
            <div>
              <div className="text-xl font-bold text-green-700" style={{ fontFamily: '"Pacifico", serif' }}>
                MUSLIM CERAMICA
              </div>
              <div className="text-xs text-gray-500">Керамогранит в Костанае</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className={`font-medium transition-colors hover:text-green-600 ${
                isActive('/') ? 'text-green-600' : 'text-gray-700'
              }`}
            >
              Главная
            </Link>
            <Link 
              to="/catalog" 
              className={`font-medium transition-colors hover:text-green-600 ${
                isActive('/catalog') ? 'text-green-600' : 'text-gray-700'
              }`}
            >
              Каталог
            </Link>
            <Link 
              to="/b2b" 
              className={`font-medium transition-colors hover:text-green-600 ${
                isActive('/b2b') ? 'text-green-600' : 'text-gray-700'
              }`}
            >
              Для профессионалов
            </Link>
            <a 
              href="https://instagram.com/kafel_muslim_ceramica" 
              target="_blank"
              className="font-medium text-gray-700 hover:text-green-600 transition-colors"
            >
              Instagram
            </a>
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center gap-4">
            <div className="text-right">
              <div className="text-sm font-semibold text-gray-800">+7 708 577-36-68</div>
              <div className="text-xs text-gray-500">Ежедневно 9:00-19:00</div>
            </div>
            <a 
              href="https://wa.me/77085773668"
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-green-600"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-4">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors hover:text-green-600 ${
                  isActive('/') ? 'text-green-600' : 'text-gray-700'
                }`}
              >
                Главная
              </Link>
              <Link 
                to="/catalog" 
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors hover:text-green-600 ${
                  isActive('/catalog') ? 'text-green-600' : 'text-gray-700'
                }`}
              >
                Каталог
              </Link>
              <Link 
                to="/b2b" 
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors hover:text-green-600 ${
                  isActive('/b2b') ? 'text-green-600' : 'text-gray-700'
                }`}
              >
                Для профессионалов
              </Link>
              <a 
                href="https://instagram.com/kafel_muslim_ceramica" 
                target="_blank"
                className="font-medium text-gray-700 hover:text-green-600 transition-colors"
              >
                Instagram
              </a>
              <div className="pt-4 border-t border-gray-200">
                <div className="text-sm font-semibold text-gray-800 mb-2">+7 708 577-36-68</div>
                <a 
                  href="https://wa.me/77085773668"
                  className="inline-flex items-center bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
